// modules
import React, { PureComponent } from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

// aliased
import HomeView from 'views/HomeView';
import PortfolioView from 'views/PortfolioView';
import ResumeView from 'views/ResumeView';
import NotFoundView from 'views/NotFoundView';
import MenuBar from 'components/MenuBar';

// local
import styles from './ColbyWebsite.pcss';

const ROUTES = (
  <Switch>
    <Route exact={ true } path='/' component={ HomeView } />
    <Route exact={ true } path='/resume' component={ ResumeView } />
    <Route exact={ false } path='/portfolio' component={ PortfolioView } />
    <Route component={ NotFoundView } />
  </Switch>
);

export default class ColbyWebsite extends PureComponent {
  
  static propTypes = {
    history: PropTypes.shape({
      listen: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }
  static defaultProps = {}
  
  componentWillMount() {
    // subscribe to history updates
    this.historyUnsub = this.props.history.listen(this.handleRouteChange);
  }
  
  componentWillUnmount = () => this.historyUnsub()
  
  handleRouteChange = ({ pathname, search } = {}) => {
    // publish google analytics page view
    // eslint-disable-next-line no-unused-expressions
    window.ga && window.ga('send', 'pageview', `${ pathname }${ search }`);
    // reset scroll position
    window.scrollTo(0, 0);
  }
    
  get menuBar() {
    const { location } = this.props;
    return (
      <MenuBar
        className={ styles.menuBar }
        fullName={ location.pathname.startsWith('/portfolio') }
        activeLink={ location.pathname } />
    );
  }
  
  render() {
    
    return (
      <div className={ styles.colbyWebsite }>
        <div className={ styles.content }>{ ROUTES }</div>
        <div className={ styles.menuBarWrap }>{ this.menuBar }</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ColbyWebsite/index.jsx